<div class="p-0 m-0">
    <div class="text-center">
        <p class="font-weight-bolder">{{productName}}</p>
        <p class="font-smaller">{{ (desc.length>40)? (desc | slice:0:40)+'..':(desc) }}</p>
    </div>
</div>

<div class="container-fluid">
    <!-- Same Product -->
    <div *ngIf="sameProduct">
        <div *ngFor="let item of sameCart;let i = index" class="cartItems">
            <label>{{productName}}</label>
            <div class="details">
                <div class="form-check form-switch bg-hover justify-content-between d-flex px-4 py-1 m-0">
                    <p *ngFor="let sub of item.item" class="subDetails"> {{sub.name}} </p>
                </div>
                <div class="cartBtn2">
                    <button (click)="removeQ(i)" type="button" class="btn  btn-sm"><span
                            class="fa fa-minus"></span></button>
                    <label for="button " class="p-2 text-center">{{item.total}}</label>
                    <button (click)="addQ(i)" type="button" class="btn  btn-sm m-md-1"><span
                            class="fa fa-plus"></span></button>
                </div>
            </div>
        </div>
    </div>

    <!-- New Or diff variations -->
    <div *ngIf="!sameProduct" class="padder">
        <div *ngFor="let item of lists">
            <list *ngIf="item.type == 'radio'">
                <list-header>
                    <label>{{item.title}}</label>
                </list-header>
                <div>
                    <div class="" *ngFor="let sub of item.items;let i = index;">
                        <div class="form-check form-switch bg-hover justify-content-between d-flex px-4 py-1 m-0">
                            <input class="form-check-input" type="radio" id="{{i}}"
                                (click)="radioGroupChange($event, item.title)" type="radio" value="{{sub.title}}"
                                name="sub.title">
                            <label class="form-check-label" for="{{i}}">{{sub.title}}</label>
                            <label class="form-check-label" for="{{i}}"> {{getCurrency()}} {{sub.price}}</label>
                        </div>

                    </div>
                </div>
            </list>
            <list *ngIf="item.type =='check'">
                <list-header>
                    <label>{{item.title}}</label>
                </list-header>
                <item *ngFor="let sub of item.items;let j = index;">
                    <div class="form-check form-switch bg-hover justify-content-between d-flex px-4 py-1 m-0">
                        <input class="form-check-input" type="checkbox" id="{{j}}"
                            (click)="checkedEvent($event,sub.title)" value="{{sub.price}}"
                            name="sub.title">
                        <label class="form-check-label" for="{{j}}">{{sub.title}}</label>
                        <label class="form-check-label" for="{{j}}">{{getCurrency()}}{{sub.price}}</label>
                    </div>
                </item>
            </list>
        </div>
    </div>
    <div class="text-center">
        <button (click)="addToCart()" class="btn btn-add text-white shadow" *ngIf="!sameProduct">
            Add {{total ? getSymobol():'' }} {{total ? total : ''}}
        </button>
        <div *ngIf="sameProduct" class="d-flex justify-content-between">

            <button class="btn btn-add text-white shadow" (click)="sameChoise()">
                OK
            </button>

            <button class="btn btn-add text-white shadow" (click)="sameProduct = !sameProduct;newItem = divue">
                Add new
            </button>

        </div>
    </div>